enum events {
    OPEN_WINDOW = 'social_planner--open_window',
    CONNECT_ACCOUNT = 'social_planner--connect_account',
    INIT_COMPLETE = 'social_planner--init_complete',
    CONNECT_ACCOUNT_MENTION_PROFILE = 'social_planner--connect_account_mention_profile',
    CONNECT_ACCOUNT_LOCATION_TAG = 'social_planner--connect_account_location_tag',
  }
  
  export default events